<template>
  <div>
    <v-data-table
      :headers="headers"
      :items="itemEntry.deals"
      :items-per-page="-1"
      hide-default-footer
    >
      <template #item.name="{ item: tempItem }">
        <v-toolbar flat color="transparent" class="broker-detail-toolbar">
          <v-toolbar-title class="body-2">
            <v-btn
              text
              :to="getAccountRoute({ name: 'deal', params: { id: tempItem._key }})"
            >
              {{ tempItem.name }}
            </v-btn>
          </v-toolbar-title>

          <div class="btn-deal-actions">
            <v-btn class="btn-deal-preview" icon @click="$emit('deal:show', tempItem)">
              <v-icon small>mdi-eye</v-icon>
            </v-btn>
            <router-link
              style="text-decoration: none"
              :to="getAccountRoute({ name: 'deal', params: { id: tempItem._key }})"
              target="_blank"
              class="btn-deal-open mr-2"
            >
              <v-btn icon>
                <v-icon small>mdi-open-in-new</v-icon>
              </v-btn>
            </router-link>
          </div>
        </v-toolbar>
      </template>
      <template #item.consideration="{ item: tempItem }">
        {{ tempItem.consideration | formatCurrencyNoDecimal }}
      </template>
      <template #item.brokerGross="{ item: tempItem }">
        {{ tempItem.brokerGross | formatCurrency }}
      </template>
      <template #item.brokerNet="{ item: tempItem }">
        <span v-if="reportTypeEntry !=='gross' ">{{ tempItem.brokerNet | formatCurrency }}</span>
      </template>
      <template #item.buildingSize="{ item: tempItem }">
        <BuildingSizeLabel :value="tempItem.buildingSize" />
      </template>
      <template #item.landSize="{ item: tempItem }">
        <LandSizeLabel :value="tempItem.landSize" />
      </template>
      <template #body.append>
        <tr class="sc-data-footer">
          <td style="min-width: 150px" />
          <td class="text-right" style="width: 200px">
            {{ itemEntry.consideration | formatCurrencyNoDecimal }}
          </td>
          <td v-if="brokerGrossShowCommission" class="text-right" style="width: 200px">
            {{ itemEntry.brokerGross | formatCurrency }}
          </td>
          <td v-if="brokerGrossShowCommission" class="text-right" style="width: 200px">
            <span v-if="reportTypeEntry !== 'gross'">{{ itemEntry.brokerNet | formatCurrency }}</span>
          </td>
          <td class="text-right" style="width: 200px">
            <BuildingSizeLabel :value="itemEntry.buildingSize" />
          </td>
          <td class="text-right" style="width: 200px">
            <LandSizeLabel :value="itemEntry.landSize" />
          </td>
        </tr>
      </template>
    </v-data-table>
  </div>
</template>

<script lang="ts">
import mixins from 'vue-typed-mixins';

import { IHeader } from '@/bundles/BaseTable/interfaces';
import { AccountLayoutMixin } from '@/bundles/App/mixins/accountMixin';

import LandSizeLabel from '@/bundles/MeasurementUnits/components/LandSizeLabel.vue';
import BuildingSizeLabel from '@/bundles/MeasurementUnits/components/BuildingSizeLabel.vue';

export default mixins(AccountLayoutMixin).extend({
  name: 'BrokerRankingCardDetails',

  components: {
    LandSizeLabel,
    BuildingSizeLabel
  },

  props: {
    itemEntry: {
      type: Object, // TODO: add type
      required: true
    },
    reportTypeEntry: {
      type: String,
      required: true,
    },
    brokerGrossShowCommission: Boolean
  },

  computed: {
    headers: function (): IHeader[] {
      const headers = [
        { text: 'Deal Name', value: 'name' },
        { text: 'Consideration', value: 'consideration', align: 'end' },
      ];

      if (this.brokerGrossShowCommission) {
        headers.push(
          { text: 'Gross', value: 'brokerGross', align: 'end' },
          { text: 'Net', value: 'brokerNet', align: 'end' },
        );
      }

      headers.push(
        { text: 'Bldg Size', value: 'buildingSize', align: 'end' },
        { text: 'Land Size', value: 'landSize', align: 'end' }
      );

      return headers;
    },
  },
});
</script>
